var _path, _g, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFindAvailability(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19614_21249",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 18,
    height: 19
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 3.5C16.0128 3.5 16.4354 3.82188 16.4932 4.23633L16.5 4.33301V5.5H17.9502C19.3584 5.5001 20.5 6.57497 20.5 7.90039V19.0996C20.5 20.425 19.3584 21.4999 17.9502 21.5H6.0498C4.64157 21.4999 3.5 20.425 3.5 19.0996V7.90039C3.5 6.57497 4.64157 5.5001 6.0498 5.5H7.5V4.33301C7.50021 3.87292 7.94785 3.5 8.5 3.5C9.01284 3.5 9.4354 3.82188 9.49316 4.23633L9.5 4.33301V5.5H14.5V4.33301C14.5002 3.87292 14.9478 3.5 15.5 3.5ZM5.2002 19.0996C5.2002 19.5414 5.58045 19.9003 6.0498 19.9004H17.9502C18.4195 19.9003 18.7998 19.5414 18.7998 19.0996V11.5H5.2002V19.0996ZM6.0498 7.09961C5.58045 7.09971 5.2002 7.45862 5.2002 7.90039V9.5H18.7998V7.90039C18.7998 7.45862 18.4195 7.09971 17.9502 7.09961H16.5V7.66699C16.4998 8.12708 16.0522 8.5 15.5 8.5C14.9872 8.5 14.5646 8.17812 14.5068 7.76367L14.5 7.66699V7.09961H9.5V7.66699C9.49979 8.12708 9.05215 8.5 8.5 8.5C7.98716 8.5 7.5646 8.17812 7.50684 7.76367L7.5 7.66699V7.09961H6.0498Z",
    fill: "#668A90"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19614_21249)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 3.5H3V11.5H12V21.5H21V3.5Z",
    fill: "#587E85"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.1374 18.3674H0.873077C0.625705 18.3674 0.418349 18.2837 0.25101 18.1164C0.0836698 17.9491 0 17.7417 0 17.4943C0 17.247 0.0836698 17.0396 0.25101 16.8723C0.418349 16.7049 0.625705 16.6212 0.873077 16.6212H7.1374L5.50038 14.9624C5.34032 14.8023 5.25665 14.6023 5.24937 14.3622C5.2421 14.1221 5.32577 13.9147 5.50038 13.7401C5.66045 13.58 5.86416 13.5 6.11154 13.5C6.35891 13.5 6.56263 13.58 6.72269 13.7401L9.86577 16.8832C10.0404 17.0578 10.1277 17.2615 10.1277 17.4943C10.1277 17.7271 10.0404 17.9309 9.86577 18.1055L6.72269 21.2486C6.56263 21.4086 6.36255 21.4923 6.12245 21.4996C5.88235 21.5068 5.675 21.4232 5.50038 21.2486C5.34032 21.0885 5.26029 20.8848 5.26029 20.6374C5.26029 20.39 5.34032 20.1863 5.50038 20.0262L7.1374 18.3674Z",
    fill: "#587E85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFindAvailability);
export default __webpack_public_path__ + "static/media/Find-Availability.dffcbe231d7a8dd216843667fa9b9228.svg";
export { ForwardRef as ReactComponent };